// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__z3Zws","pulse":"styles_pulse__t_Tod","jump":"styles_jump__uA_IZ","wiggle":"styles_wiggle__3xvQo"};